import * as DateUtilities from "./DateUtilities";

// Function for dynamic sorting
export function compareValues(key, order='asc') {

	// Console logging flag
	const logToConsole = false;

	// TODO: Make output a variable; move logging condition to bottom of function and log output too
	// Console logging
	if (logToConsole) {
		console.log(
			'%c compareValues', 'font-weight: bold; color: none',
			'\n' + ' - key.typeof:', typeof key,
			'\n' + ' - order.typeof:', typeof order + '\n',
			{ key },
			{ order }
		);
	}

	return function(a, b) {
		if(!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
			// property doesn't exist on either object
			return 0;
		}

		const varA = (typeof a[key] === 'string') ?
			a[key].toUpperCase() : a[key];
		const varB = (typeof b[key] === 'string') ?
			b[key].toUpperCase() : b[key];

		let comparison = 0;
		if (varA > varB) {
			comparison = 1;
		} else if (varA < varB) {
			comparison = -1;
		}
		return (
			(order === 'desc') ? (comparison * -1) : comparison
		);
	};
}

// Function for date sorting
export function sortDates(field) {

	// https://stackoverflow.com/questions/10123953/how-to-sort-an-array-by-a-date-property
	// Turn your strings into dates, and then subtract them
	// to get a value that is either negative, positive, or zero.

	// Console logging flag
	const logToConsole = false;

	// TODO: Make output a variable; move logging condition to bottom of function and log output too
	// Console logging
	if (logToConsole) {
		console.log(
			'%c sortDates', 'font-weight: bold; color: none',
			'\n' + ' - field.typeof:', typeof field + '\n',
			{ field }
		);
	}

	return function(a, b) {
		// let aOutput = (a.getMonth() + 1) + '/' + a.getDate() + '/' + a.getFullYear();
		// console.log(aOutput);
		//
		// let bOutput = (b.getMonth() + 1) + '/' + b.getDate() + '/' + b.getFullYear();
		// console.log(bOutput);

		// const inputAsDate = a instanceof Date ? 'date' : 'not a date';
		// console.log(inputAsDate);
		// console.log(a);
		// console.log(a[field]);
		// console.log(new Date(a[field]));
		// const inputAsDate2 = b instanceof Date ? 'date' : 'not a date';
		// console.log(inputAsDate2);
		// console.log(b);
		// console.log(b[field]);
		// console.log(new Date(b[field]));

		let aDate = a;
		let bDate = b;
		if (typeof field !== 'undefined'){
			aDate = a[field]
			bDate = b[field]
		}

		// console.log(new Date(aDate));
		// console.log(new Date(bDate));
		return new Date(aDate) - new Date(bDate);
	}
}


// Function for performing data filtering
export function filterDataSet(
	conditionType,			// value (compare to a specific value), month (compare current month to date within dataSet), group (compare to multiple values)
	conditionOperator, 		// eq (equals), gt (greater than), lt (less than), + (addition), - (subtraction), in (in)
	conditionField, 		// initial field in dataSet to compare against
	conditionValue, 		// specific value to compare
	dataSet, 				// Object with defined data set
	valueField				// field from dataSet to be returned when condition is met
	) {

	// Console logging flag
	const logToConsole = false;

	// TODO: Make output a variable; move logging condition to bottom of function and log output too
	// Console logging
	if (logToConsole) {
		console.log(
			'%c filterDataSet', 'font-weight: bold; color: none',
			'\n' + ' - conditionType.typeof:', typeof conditionType,
			'\n' + ' - conditionOperator.typeof:', typeof conditionOperator,
			'\n' + ' - conditionField.typeof:', typeof conditionField,
			'\n' + ' - conditionValue.typeof:', typeof conditionValue,
			'\n' + ' - dataSet.typeof:', typeof dataSet,
			'\n' + ' - valueField.typeof:', typeof valueField + '\n',
			{ conditionType },
			{ conditionOperator },
			{ conditionField },
			{ conditionValue },
			{ dataSet },
			{ valueField }
		);
	}

	switch (conditionType) {
		case 'value':
			if (conditionOperator === ('eq')) {
				return dataSet.find((item) => {
					if (conditionValue === item[conditionField]) {
						if (valueField) {
							return item[valueField];
						} else {
							return item;
						}
					}
				});
			} else if (conditionOperator === ('neq')) {
				return dataSet.find((item) => {
					if (conditionValue !== item[conditionField]) {
						if (valueField) {
							return item[valueField];
						} else {
							return item;
						}
					}
				});
			} else if (conditionOperator === ('gt')) {
				return dataSet.find((item) => {
					if (conditionValue > item[conditionField]) {
						if (valueField) {
							return item[valueField];
						} else {
							return item;
						}
					}
				})
			} else if (conditionOperator === ('lt')) {
				return dataSet.find((item) => {
					if (conditionValue < item[conditionField]) {
						if (valueField) {
							return item[valueField];
						} else {
							return item;
						}
					}
				})
			}
			break;
		case 'month':
			const d = new Date();
			const currentMonth = d.getMonth();
			const compareMonth = DateUtilities.dateMonthDigitString(dataSet[conditionField]);
			if (conditionOperator === ('eq')) {
				if (currentMonth === compareMonth) {
					return dataSet[valueField];
				}
			} else if (conditionOperator === ('gt')) {
				if (compareMonth > currentMonth) {
					return dataSet[valueField];
				}
			} else if (conditionOperator === ('lt')) {
				if (compareMonth < currentMonth) {
					return dataSet[valueField];
				}
			} else if (conditionOperator === ('+')) {
				const newMonth = new Date(d.setMonth(currentMonth + conditionValue));
				if (newMonth.getMonth() === compareMonth) {
					return dataSet[valueField];
				}
			} else if (conditionOperator === ('-')) {
				const newMonth = new Date(d.setMonth(currentMonth - conditionValue));
				if (newMonth.getMonth() === compareMonth) {
					return dataSet[valueField];
				}
			}
			break;
		case 'pathname':
			// if (dataSet.length > 1) {
				if (conditionOperator === ('eq')) {
					return dataSet.find((item) => {
						if (conditionValue === item[conditionField]) {
							if (valueField) {
								return item[valueField];
							} else {
								return item;
							}
						}
					});
				}
			// } else if (dataSet.length === 1) {
			// 	console.log('data 1');
			// 	if (conditionOperator === ('eq')) {
			// 		console.log(conditionValue);
			// 		console.log(dataSet);
			// 		if (conditionValue === dataSet[conditionField]) {
			// 			if (valueField) {
			// 				return dataSet[valueField];
			// 			} else {
			// 				return dataSet;
			// 			}
			// 		}
			// 	}
			// }
			break;
		case 'full':
			if (conditionOperator === ('eq')) {
				// console.log(conditionField);
				// console.log(conditionValue);
				let newDataSet = dataSet.filter((d) => d[conditionField] === conditionValue);
				// console.log(newDataSet);
				return newDataSet;
			} else if (conditionOperator === ('neq')) {
				// console.log(conditionField);
				// console.log(conditionValue);
				let newDataSet = dataSet.filter((d) => d[conditionField] !== conditionValue);
				// console.log(newDataSet);
				return newDataSet;
			} else if (conditionOperator === ('isnull')) {
				// console.log(conditionField);
				// console.log(conditionValue);
				let newDataSet = dataSet.filter((d) => d[conditionField] === null);
				// console.log(newDataSet);
				return newDataSet;
			} else if (conditionOperator === ('isnotnull')) {
				// console.log(conditionField);
				// console.log(conditionValue);
				let newDataSet = dataSet.filter((d) => d[conditionField] !== null);
				// console.log(newDataSet);
				return newDataSet;
			}
			break;
		case 'group':
			if (conditionOperator === ('in')) {
				// console.log(conditionField);
				// console.log(conditionValue);
				let newDataSet = dataSet.filter((d) => {
					for (let i = 0; i < conditionValue.length; i++) {
						if (d[conditionField].toLowerCase() === conditionValue[i].toLowerCase()) {
							return d
						}
					}
				});
				// console.log(newDataSet);
				return newDataSet;
			}
			break;
		default:
			break;
	}
}